import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
const ReIntentReasoning = (props) => {
    const { personalized_recommend_re_intent_reasoning = '' } = props;
    return (
        <>
            <div>
                <GrtAiMarkdown
                    className="ai-markdown-box"
                    thinkText="正在理解需求"
                    thoughtText="已理解学习需求"
                    content={personalized_recommend_re_intent_reasoning}
                ></GrtAiMarkdown>
            </div>
        </>
    );
};
export default ReIntentReasoning;
